// Dependecies

import React, { useState, useEffect } from 'react';
import { reject } from 'lodash';
import { useAccordionToggle } from 'react-bootstrap';
import PropTypes from 'prop-types';
// Store
import user from '../../store/user';
import maintenance from '../../store/maintenances';

// Hooks
import useLanguage from '../useLanguage';

// Image
import check from '../../../sass/images/icons/check.svg';

function useQualifyService() {
  const [reload, setReload] = useState(false);
  const [qualifyService, setQualifyService] = useState([]);
  const [qualifyServiceBool, setQualifyServiceBool] = useState(0);
  const [openModalStarsInvert, setOpenModalStarsInvert] = useState(false);
  const [idService, setIdService] = useState(0);
  const [userStore] = user();
  const [storeMantenaice, maintenancesActions] = maintenance();
  const [openModalImage, setopenModalImage] = useState(false);
  const [urlImageService, setUrlImageService] = useState('');
  const { locale } = useLanguage();
  const [star, setStar] = useState(0);
  const [imagen, setImagen] = useState(check);
  const [valuePlate, setValuePlate] = useState(0);
  const [loader, setLoader] = useState(false);
  const [successfully, setSuccessfully] = useState(storeMantenaice.successfully);
  const [filterCompany, setFilterCompany] = useState(false);

  useEffect(() => {
    if (userStore.token) {
      const data2 = {
        licensePlate: valuePlate,
      };

      maintenancesActions.setQualityService(userStore.token, data2, locale).then(
        (maintenancesResponse) => {
          setQualifyService(maintenancesResponse.service);
          setQualifyServiceBool(maintenancesResponse.servicesTotal);
          setReload(true);
          setFilterCompany(false);
        },
        (e) => {
          if (e.status === 401) {
            reject(e);
          }
          reject('Error');
        }
      );
    }
  }, [userStore.token, filterCompany, loader]);

  function update(
    id,
    optionSelect,
    whyRejectIt,
    status,
    questionnaire,
    stars,
    read,
    companyObservations,
    companyStars
  ) {
    const data = {
      id,
      option: optionSelect,
      whyRejectIt,
      status,
      questionnaire,
      stars,
      read,
      companyObservations,
      companyStars,
    };
    if (userStore.token) {
      maintenancesActions.update(userStore.token, data).then(
        (response) => {
          if (response.status === 200) {
            reject(response);
            setOpenModalStarsInvert(false);
            setLoader(true);
            setSuccessfully(true);
          }
        },
        (e) => {
          if (e.status === 401) {
            reject(e);
          }
        }
      );
    }
  }

  function CustomToggle({ children, eventKey, handleClick }) {
    const decoratedOnClick = useAccordionToggle(eventKey, () => {
      handleClick();
    });

    return (
      <div className="arrow-card" onClick={decoratedOnClick}>
        {children}
      </div>
    );
  }
  CustomToggle.propTypes = {
    children: PropTypes.node.isRequired,
    eventKey: PropTypes.number.isRequired,
    handleClick: PropTypes.func.isRequired,
  };

  const closeModal = () => {
    setOpenModalStarsInvert(false);
    setopenModalImage(false);
  };

  const onSubmitStartCompany = (data, id) => {
    update(id, 'Finalized', '', 4, '', '', true, data.description, data.stars);
    closeModal();
  };

  function searchLicensePlate(plate, img) {
    if (plate !== '') {
      setImagen(img);
    } else {
      setValuePlate(0);
      setImagen(img);
    }
    setFilterCompany(true);
  }

  function aproveService(id) {
    setIdService(id);
    setOpenModalStarsInvert(true);
  }
  function setUrlImageServices(img) {
    setUrlImageService(img);
    setopenModalImage(true);
  }

  return {
    qualifyService,
    qualifyServiceBool,
    openModalStarsInvert,
    closeModal,
    idService,
    onSubmitStartCompany,
    star,
    setStar,
    CustomToggle,
    searchLicensePlate,
    imagen,
    valuePlate,
    setValuePlate,
    aproveService,
    successfully,
    setSuccessfully,
    reload,
    setUrlImageServices,
    urlImageService,
    openModalImage,
  };
}

export default useQualifyService;
